module.exports = __webpack_public_path__ + "static/Black_Dragon-42b69248ef764a56128ba4a0ea29f718.jpg";